import { Dayjs } from 'dayjs';
import { capitalize } from 'lodash';

export const formatDate = (date: Dayjs | undefined) =>
  date ? capitalize(date.format('dddd, D MMMM YYYY')) : '-';

export const formatTime = (start: Dayjs | undefined, end: Dayjs | undefined) =>
  start && end ? `${start.format('HH:mm')} - ${end.format('HH:mm')}` : '-';

// A session that runs past midnight ends on a date its start date does not name, so the range
// carries both days and the times below it stay readable as a pair.
export const formatDateRange = (
  start: Dayjs | undefined,
  end: Dayjs | undefined,
) =>
  start && end && !start.isSame(end, 'day')
    ? `${formatDate(start)} - ${formatDate(end)}`
    : formatDate(start);

export const getTimeOfDay = (date: Dayjs) => {
  return date.year(0).month(0).date(1);
};
